let mutations = {
    ERROR(state, error) {
        console.log("mutate", error);
        if (error.response) {
            var err = {
                status: error.response.status,
                message: error.response.data.MESSAGE,
            };
        } else if (error.request) {
            var err = {
                status: "",
                message:
                    "Network connection occurred. Data request not completed",
            };
        } else {
            var err = {
                status: "",
                message: error.message,
            };
        }

        return (state.error = err);
    },
    FETCH_USER(state, user) {
        return (state.user = user);
    },
    FETCH_LOCATIONS(state, locations) {
        return (state.locations = locations);
    },
    FETCH_JEWEL_OPTIONS(state, jewelOptions) {
        return (state.jewelOptions = jewelOptions);
    },
    FETCH_VALUATION_INDEX_OPTIONS(state, valuationIndexOptions) {
        return (state.valuationIndexOptions = valuationIndexOptions);
    },
    FETCH_VALUATION_INDEX(state, valuationIndexResult) {
        return (state.valuationIndexResult = valuationIndexResult);
    },
    FETCH_VALUATION_ESTIMATE(state, valuationEstimateResult) {
        return (state.valuationEstimateResult = valuationEstimateResult);
    },
    FETCH_VALUATION_INDEX_TABLES(state, valuationIndexTable) {
        return state.valuationIndexTables.push(valuationIndexTable);
    },
};
export default mutations;
